import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // Import Tailwind CSS
import "./i18n"; // Ensure i18n is imported

// Theme is preloaded server-side as CSS, so no need to wait
// CSS variables are available immediately when the HTML is parsed
const rootElement = document.getElementById("root");
if (!rootElement) {
 console.error("[REACT] Root element not found");
} else {
 const reactRoot = ReactDOM.createRoot(rootElement);
 reactRoot.render(
  <React.StrictMode>
   <App />
  </React.StrictMode>
 );
}
